/**
 * @generated SignedSource<<6e27d02f9cc5b85d299a71337aab6a6c>>
 * @relayHash 91cc0384b762404606db949056d3a3c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 92e211e48c2af32d59acf53fdae8ddcf8b0883b0883487b88121f7eb9704874d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceGroupUsageType = "ADMIN_OVERSIGHT" | "TEAM_COLLABORATION" | "USERBASE_GROUP" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useFetchRestrictionsRESTObjRestrictionsRESTQuery$variables = {
  contentId: string;
  draftShareId?: string | null | undefined;
};
export type useFetchRestrictionsRESTObjRestrictionsRESTQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly restrictions: {
        readonly read: {
          readonly operation: string | null | undefined;
          readonly restrictions: {
            readonly groupWithRestrictions: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
                readonly usageType: ConfluenceGroupUsageType | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly userWithRestrictions: {
              readonly nodes: ReadonlyArray<{
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly email: string | null | undefined;
                readonly hasSpaceEditPermission: boolean | null | undefined;
                readonly hasSpaceViewPermission: boolean | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly publicName: string | null | undefined;
                readonly type: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly update: {
          readonly operation: string | null | undefined;
          readonly restrictions: {
            readonly groupWithRestrictions: {
              readonly nodes: ReadonlyArray<{
                readonly id: string | null | undefined;
                readonly name: string | null | undefined;
                readonly usageType: ConfluenceGroupUsageType | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
            readonly userWithRestrictions: {
              readonly nodes: ReadonlyArray<{
                readonly accountId: string | null | undefined;
                readonly displayName: string | null | undefined;
                readonly email: string | null | undefined;
                readonly hasSpaceEditPermission: boolean | null | undefined;
                readonly hasSpaceViewPermission: boolean | null | undefined;
                readonly permissionType: SitePermissionType | null | undefined;
                readonly profilePicture: {
                  readonly path: string;
                } | null | undefined;
                readonly publicName: string | null | undefined;
                readonly type: string | null | undefined;
              } | null | undefined> | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useFetchRestrictionsRESTObjRestrictionsRESTQuery = {
  response: useFetchRestrictionsRESTObjRestrictionsRESTQuery$data;
  variables: useFetchRestrictionsRESTObjRestrictionsRESTQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "draftShareId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "type"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "operation"
  },
  {
    "concreteType": "SubjectsByType",
    "kind": "LinkedField",
    "name": "restrictions",
    "plural": false,
    "selections": [
      {
        "concreteType": "PaginatedGroupWithRestrictions",
        "kind": "LinkedField",
        "name": "groupWithRestrictions",
        "plural": false,
        "selections": [
          {
            "concreteType": "GroupWithRestrictions",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "usageType"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PaginatedUserWithRestrictions",
        "kind": "LinkedField",
        "name": "userWithRestrictions",
        "plural": false,
        "selections": [
          {
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "accountId"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "email"
              },
              {
                "kind": "ScalarField",
                "name": "hasSpaceEditPermission"
              },
              {
                "kind": "ScalarField",
                "name": "hasSpaceViewPermission"
              },
              {
                "kind": "ScalarField",
                "name": "permissionType"
              },
              {
                "kind": "ScalarField",
                "name": "publicName"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              },
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  }
],
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "draftShareId",
        "variableName": "draftShareId"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "status",
        "value": [
          "current",
          "draft"
        ]
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "concreteType": "ContentRestrictions",
            "kind": "LinkedField",
            "name": "restrictions",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContentRestriction",
                "kind": "LinkedField",
                "name": "read",
                "plural": false,
                "selections": (v3/*: any*/)
              },
              {
                "concreteType": "ContentRestriction",
                "kind": "LinkedField",
                "name": "update",
                "plural": false,
                "selections": (v3/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
    "selections": (v4/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "91cc0384b762404606db949056d3a3c6",
    "id": "92e211e48c2af32d59acf53fdae8ddcf8b0883b0883487b88121f7eb9704874d",
    "metadata": {},
    "name": "useFetchRestrictionsRESTObjRestrictionsRESTQuery",
    "operationKind": "query",
    "text": "query useFetchRestrictionsRESTObjRestrictionsRESTQuery($contentId:ID!,$draftShareId:String){content(id:$contentId,status:[\"current\",\"draft\"],draftShareId:$draftShareId){nodes{id,type,restrictions{read{operation,restrictions{groupWithRestrictions{nodes{id,name,usageType}},userWithRestrictions{nodes{accountId,displayName,email,hasSpaceEditPermission,hasSpaceViewPermission,permissionType,publicName,profilePicture{path},type}}}},update{operation,restrictions{groupWithRestrictions{nodes{id,name,usageType}},userWithRestrictions{nodes{accountId,displayName,email,hasSpaceEditPermission,hasSpaceViewPermission,permissionType,publicName,profilePicture{path},type}}}}}}}}"
  }
};
})();

(node as any).hash = "1686b4bcd3c285ffedbae0d2babd7b98";

export default node;
